/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated with ApiClientGenerator, using the NSwag toolchain
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import axios, { AxiosRequestConfig, AxiosPromise, CancelToken } from 'axios';
import { injectable, inject, optional, symbolToken } from '@servicetitan/react-ioc';
import { makeCodedException, makeContent } from 'utils';
// @ts-ignore: needed for Date serialization if a DateTime parameter has an Unspecified attribute on it
import moment from 'moment';
import { AxiosInstance } from 'axios';

export interface IPortalEstimates {
    get(id: string, cancelToken?: CancelToken): AxiosPromise<EstimateBundleV2>;
    acceptGET(request: AcceptRequestV2, cancelToken?: CancelToken): AxiosPromise<FileResponse>;
    acceptPOST(request: AcceptRequestV2, cancelToken?: CancelToken): AxiosPromise<FileResponse>;
    acceptEstimate(
        estimateId: number,
        request: AcceptEstimateRequestV2,
        cancelToken?: CancelToken
    ): AxiosPromise<FileResponse>;
    getEstimateContainersWithFilter(
        filterModel: ProposalSearchCriteria,
        cancelToken?: CancelToken
    ): AxiosPromise<EstimateContainerWebModel[]>;
    getEstimateContainers(cancelToken?: CancelToken): AxiosPromise<EstimateContainerWebModel[]>;
    getEstimateContainer(
        id: string,
        cancelToken?: CancelToken
    ): AxiosPromise<EstimateContainerWebModel>;
    getPdfDocument(id: number, cancelToken?: CancelToken): AxiosPromise<FileResponse>;
    getEstimatesDepositSettings(cancelToken?: CancelToken): AxiosPromise<DepositSettingsWebModel>;
}

export const BASE_URL_TOKEN_PortalEstimates = symbolToken<string>('BASE_URL_TOKEN', false);

@injectable()
export class PortalEstimates implements IPortalEstimates {
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(private axios: AxiosInstance, private readonly baseUrl = '') {}

    get(id: string, cancelToken?: CancelToken): AxiosPromise<EstimateBundleV2> {
        let url_ = '/v1/customerportal2/estimates/{id}';
        if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace('{id}', encodeURIComponent('' + id));
        url_ = url_.replace(/[?&]$/, '');

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            url: url_,
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            },
        };

        return makeCodedException(this.axios.request<EstimateBundleV2>(options_));
    }

    acceptGET(request: AcceptRequestV2, cancelToken?: CancelToken): AxiosPromise<FileResponse> {
        let url_ = '/v1/customerportal2/estimates/accept';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = request;

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            data: content_,
            responseType: 'blob',
            url: url_,
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            },
        };

        return makeCodedException(this.axios.request<FileResponse>(options_));
    }

    acceptPOST(request: AcceptRequestV2, cancelToken?: CancelToken): AxiosPromise<FileResponse> {
        let url_ = '/v1/customerportal2/estimates/accept';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = request;

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            data: content_,
            responseType: 'blob',
            url: url_,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            },
        };

        return makeCodedException(this.axios.request<FileResponse>(options_));
    }

    acceptEstimate(
        estimateId: number,
        request: AcceptEstimateRequestV2,
        cancelToken?: CancelToken
    ): AxiosPromise<FileResponse> {
        let url_ = '/v1/customerportal2/estimates/{estimateId}/accept';
        if (estimateId === undefined || estimateId === null)
            throw new Error("The parameter 'estimateId' must be defined.");
        url_ = url_.replace('{estimateId}', encodeURIComponent('' + estimateId));
        url_ = url_.replace(/[?&]$/, '');

        const content_ = request;

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            data: content_,
            responseType: 'blob',
            url: url_,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            },
        };

        return makeCodedException(this.axios.request<FileResponse>(options_));
    }

    getEstimateContainersWithFilter(
        filterModel: ProposalSearchCriteria,
        cancelToken?: CancelToken
    ): AxiosPromise<EstimateContainerWebModel[]> {
        let url_ = '/v1/customerportal2/estimates/containers';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = filterModel;

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            data: content_,
            url: url_,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            },
        };

        return makeCodedException(this.axios.request<EstimateContainerWebModel[]>(options_));
    }

    getEstimateContainers(cancelToken?: CancelToken): AxiosPromise<EstimateContainerWebModel[]> {
        let url_ = '/v1/customerportal2/estimates/containers';
        url_ = url_.replace(/[?&]$/, '');

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            url: url_,
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            },
        };

        return makeCodedException(this.axios.request<EstimateContainerWebModel[]>(options_));
    }

    getEstimateContainer(
        id: string,
        cancelToken?: CancelToken
    ): AxiosPromise<EstimateContainerWebModel> {
        let url_ = '/v1/customerportal2/estimates/containers/{id}';
        if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace('{id}', encodeURIComponent('' + id));
        url_ = url_.replace(/[?&]$/, '');

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            url: url_,
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            },
        };

        return makeCodedException(this.axios.request<EstimateContainerWebModel>(options_));
    }

    getPdfDocument(id: number, cancelToken?: CancelToken): AxiosPromise<FileResponse> {
        let url_ = '/v1/customerportal2/estimates/{id}/pdf';
        if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace('{id}', encodeURIComponent('' + id));
        url_ = url_.replace(/[?&]$/, '');

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            responseType: 'blob',
            url: url_,
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            },
        };

        return makeCodedException(this.axios.request<FileResponse>(options_));
    }

    getEstimatesDepositSettings(cancelToken?: CancelToken): AxiosPromise<DepositSettingsWebModel> {
        let url_ = "/v1/customerportal2/estimates/deposit-settings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            url: url_,
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return makeCodedException(this.axios.request<DepositSettingsWebModel>(options_));
    }
}

export interface EstimateBundleV2 {
    id: string;
    estimates: EstimateV2[];
    priceOptions: PriceOptionsV2;
    financingPresentationSetting?: PresentationSettingsState | undefined;
    financingEnabled: boolean;
    programName?: string | undefined;
}

export interface EstimateV2 {
    id: string;
    buId: number;
    tenantId: number;
    jobId: number;
    projectId: number;
    technicianId: number;
    customer: FinancingCustomerV2;
    items: EstimateItemV2[];
    isAccepted: boolean;
    name: string;
    summary: string;
    subtotal?: number | undefined;
    tax?: number | undefined;
    memberSavingsMin?: number | undefined;
    memberSavingsMax?: number | undefined;
    isMember: boolean;
    total?: number | undefined;
    terms?: string | undefined;
    termsFileName?: string | undefined;
    proposalTagName?: string | undefined;
    proposalTagColor?: string | undefined;
    stateCode?: string | undefined;
}

export interface FinancingCustomerV2 {
    id: number;
    firstName: string;
    middleName?: string | undefined;
    lastName: string;
    address: CustomerAddressV2;
}

export interface CustomerAddressV2 {
    streetAddress: string;
    unit?: string | undefined;
    city: string;
    state: string;
    zip: string;
}

export interface EstimateItemV2 {
    name: string;
    description: string;
    standardPrice?: number | undefined;
    memberSavingsMin?: number | undefined;
    memberSavingsMax?: number | undefined;
    yourPrice?: number | undefined;
    imageUris?: string[] | undefined;
}

export enum PriceOptionsV2 {
    Show = 0,
    Hide = 1,
    HideLineItem = 2,
}

export enum PresentationSettingsState {
    LeadWithMonthlyPrice = 0,
    LeadWithTotalPrice = 1,
    OnlyDisplayMonthlyPrice = 2,
    OnlyDisplayTotalPrice = 3,
}

export interface AcceptRequestV2 {
    bundleId: string;
    estimateId: string;
    signatureImage?: string | undefined;
    signatureText?: string | undefined;
    notificationEmail: string;
    ipAddress: string;
}

export interface AcceptEstimateRequestV2 {
    signatureImage?: string | undefined;
    signatureText?: string | undefined;
}

export interface EstimateContainerWebModel {
    id: string;
    opportunityId: string;
    name: string;
    description?: string | undefined;
    estimates: EstimateModel[];
    createdOn: Date;
    jobType?: JobTypeModel | undefined;
    jobStatus?: JobStatus | undefined;
    serviceLocation?: LocationModel | undefined;
    showEstimateTotalPrice?: boolean | undefined;
}

export interface EstimateModel {
    id: number;
    name: string;
    summary: string;
    status: EstimateStatus;
    expired: boolean;
    optionName?: string | undefined;
    optionColorHex?: string | undefined;
    imageUrl?: string | undefined;
    totalPrice?: number | undefined;
    totalPayment: number;
    depositAmount?: number | undefined;
}

export enum EstimateStatus {
    Open = 0,
    Sold = 1,
    Dismissed = 2,
}

export interface JobTypeModel {
    id: number;
    name: string;
}

export enum JobStatus {
    Scheduled = 0,
    Dispatched = 1,
    InProgress = 2,
    Hold = 3,
    Completed = 4,
    Canceled = 5,
}

export interface LocationModel {
    id: number;
    name: string;
    address?: AddressModel | undefined;
}

export interface AddressModel {
    street?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zip?: string | undefined;
    unit?: string | undefined;
}

export interface ProposalSearchCriteria {
    customerIds?: number[] | undefined;
    jobNumber?: string | undefined;
    serviceLocationIds?: number[] | undefined;
    jobTypeIds?: number[] | undefined;
    jobCreatedDate?: DateRange | undefined;
    statuses?: ProposalStatus[] | undefined;
    estimateFilterOverride?: EstimateStatusSettingFilter | undefined;
}

export interface DateRange {
    start?: Date | undefined;
    end?: Date | undefined;
}

export enum ProposalStatus {
    Open = 0,
    Accepted = 1,
    Dismissed = 2,
}

export enum EstimateStatusSettingFilter {
    None = 0,
    Open = 1,
    Accepted = 2,
    Dismissed = 4,
    All = 7,
}

export interface DepositSettingsWebModel {
    globalDefaultEnabled: boolean;
    globalDepositPercent: number;
}

export type FileResponse = Blob;